import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue';

interface IProps {
  text: string;
  classes?: string[];
  noMargin?: boolean;
  fontSize?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomSubTitle',
  props: {
    text: null,
    classes: null,
    noMargin: { type: Boolean },
    fontSize: null
  },
  setup(__props: any) {

const props = __props as { text: string, classes?: string[], noMargin?: boolean, fontSize?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    style: _normalizeStyle({ marginBottom: __props.noMargin ? 0 : '32px', fontSize: __props.fontSize? __props.fontSize:'' }),
    class: _normalizeClass(__props.classes)
  }, _toDisplayString(props.text), 7))
}
}

})